import * as React from "react";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import Button from "@mui/material/Button";
import LoadingSpinner from "../../common/components/LoadingSpinner";
import Typography from "@mui/material/Typography";

export default function CommandType(props) {
  const [selectedValues, setSelectedValues] = React.useState([]);
  const [openCellModal, setOpenCellModal] = React.useState(false);
  const [selectedCells, setSelectedCells] = React.useState([]);

  const handleChange = (event) => {
    const id = parseInt(event.target.value);

    if (selectedValues.includes(id)) {
      setSelectedValues(selectedValues.filter((v) => v !== id));
    } else {
      setSelectedValues([...selectedValues, id]);
    }
  };

const handleAddStepsToCells = () => {
  selectedCells.forEach((cellId) => {
    selectedValues.forEach((commandId) => {
      props.onClick({ cellId, commandId, closeAfter: false });
    });
  });

  setOpenCellModal(false);
  setSelectedCells([]);
  props.onDone?.();
};



  if (props.loading || !props.data[0] || !props.data[0].name) {
    return (
      <LoadingSpinner
        style={{ margin: "80px auto", position: "relative", top: "unset" }}
      />
    );
  }

  return (
    <>
      <div style={{ padding: "16px 0px", width: "100%" }}>
        <Typography variant="subtitle1">Add a new command step</Typography>
        <Typography variant="caption" color="textSecondary">
          A command step is unseen by the respondent and can trigger a
          calibration, recalibration, start or stop of the camera.
        </Typography>
      </div>

      <div style={{ margin: "24px auto", display: "grid" }}>
        <FormControl component="fieldset">
          <FormLabel component="legend">Command step type</FormLabel>

          <FormGroup>
            {props.data.map((commandType) => (
              <FormControlLabel
                key={commandType.id}
                control={
                  <Checkbox
                    checked={selectedValues.includes(commandType.id)}
                    value={commandType.id}
                    onChange={handleChange}
                  />
                }
                label={commandType.name}
              />
            ))}
          </FormGroup>
        </FormControl>

        <Button
          className="button-primary"
          style={{ marginTop: 16 }}
          // color="info"
          disabled={selectedValues.length === 0} 
          onClick={() => setOpenCellModal(true)} 
          variant="contained"
        >
          Add step
        </Button>
      </div>
{openCellModal && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(0,0,0,0.4)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 99999,
    }}
  >
    <div style={{ background: "white", padding: 24, borderRadius: 8, width: 400 }}>
      <Typography variant="h6" style={{ marginBottom: 12 }}>
        Select cells
      </Typography>

      <FormGroup>
        {/* SELECT ALL */}
        <FormControlLabel
          control={
            <Checkbox
              checked={selectedCells.length === props.cells.length}
              onChange={() => {
                if (selectedCells.length === props.cells.length) {
                  setSelectedCells([]);
                } else {
                  setSelectedCells(props.cells.map(c => c.id));
                }
              }}
            />
          }
          label="Select All"
        />

        {/* INDIVIDUAL CELLS */}
        {props.cells.map(cell => (
          <FormControlLabel
            key={cell.id}
            control={
              <Checkbox
                checked={selectedCells.includes(cell.id)}
                onChange={() => {
                  if (selectedCells.includes(cell.id)) {
                    setSelectedCells(selectedCells.filter(id => id !== cell.id));
                  } else {
                    setSelectedCells([...selectedCells, cell.id]);
                  }
                }}
              />
            }
            label={cell.cellName}
          />
        ))}
      </FormGroup>

      <div style={{ marginTop: 16, display: "flex", justifyContent: "flex-end" }}>
        <Button onClick={() => setOpenCellModal(false)} style={{ marginRight: 8 }}>
          Cancel
        </Button>

        <Button
          disabled={selectedCells.length === 0}
          variant="contained"
          onClick={() => handleAddStepsToCells()}
        >
          Confirm
        </Button>
      </div>
    </div>
  </div>
)}

    </>
  );
}
